import React from "react";
import { Menu } from "lucide-react";

export default function Header(props: any) {
  return (
    <>
     {/* Mobile Header */}
      <div className="flex items-center justify-between md:hidden mb-6">
        <h1 className="text-xl font-bold text-gray-900">MD Questionnaire</h1>
        <button onClick={props.onSidebarClick}>
          <Menu className="w-6 h-6 text-gray-700" />
        </button>
      </div>
        {/* Desktop Header */}
      <header className="mb-8 hidden md:block">
        <h1 className="text-3xl font-bold text-gray-900">Momentum Diagnostic (MD) Questionnaire</h1>
        <p className="text-gray-500">Evaluate Your Agency’s Total Performance</p>
        <p className="text-green-600 font-semibold italic mt-1">Focus and Grow</p>
      </header>
    </>
  );
}
